<p-dialog modal="true" styleClass="atlas-dialog-m" position="center" [closable]="false" [(visible)]="showDialog">
  <ng-template pTemplate="header">
    {{ 'public-links.upgrade-all-pages' | translate | titlecase }}
  </ng-template>
  <div class="mv-10 mb-20">
    {{ 'public-links.upgrade-dialog.message' | translate }}
    <span class="italic">{{ 'public-links.upgrade-dialog.web-pref-path' | translate | titlecase }}.</span>
  </div>
  <div>
    <a href="https://atlas.memberclicks.com/hc/en-us/articles/26046686076685-Upgrade-Web-Component-Pages"
      target="_blank">
      {{ 'public-links.upgrade-dialog.more-information' | translate | ucfirst }}
    </a>
  </div>
  <div class="mv-10 mct-flex mct-row mct-justify-end mct-items-center mct-gap-10"   >
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="close()">
      {{ 'public-links.upgrade-dialog.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="handleUpdateSetings()">
      {{ 'public-links.upgrade-all-pages' | translate | uppercase }}
    </button>
  </div>
</p-dialog>